import { buildOrderLineTree } from './OrderLineTreeBuilder';
import { runOrderPricingPipeline } from './OrderPricingPipeline';
import { createOrderBuildSession } from './OrderBuildSession';
import { ApmHelper, ApmSpanType } from '../libraries/ApmHelper';
const mapToOrderLinesG5 = (productCatalog, productSelection, options = {}, orderTags = [], includedPriceDisabled = false, discountTypeDisabled = []) => {
    if (!productCatalog || !productCatalog.products || !productCatalog.products.length) {
        return [];
    }
    const session = createOrderBuildSession({
        cartProductsMap: options === null || options === void 0 ? void 0 : options.cartProductsMap,
        exceededPriceRules: options === null || options === void 0 ? void 0 : options.exceededPriceRules,
        isRootProductMenu: options === null || options === void 0 ? void 0 : options.isRootProductMenu,
    });
    const orderLines = buildOrderLineTree({
        productCatalog,
        productSelection,
        options,
        session,
    });
    return runOrderPricingPipeline({
        productCatalog,
        orderLines,
        options,
        orderTags,
        includedPriceDisabled,
        discountTypeDisabled,
        session,
    });
};
export default ApmHelper.apmDecorator(mapToOrderLinesG5, {
    apmLabel: 'OrderLineMappingsG5',
    apmType: ApmSpanType.PURE_FUNCTION,
});
